<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = size;
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg
	{width}
	{height}
	viewBox="0 0 17 17"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class="icon"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M16.9044 10.8804C17.0888 9.88704 17.0148 8.83034 16.6095 7.90136C15.8365 6.13945 14.9155 5.94733 14.1789 5.72243C14.1789 5.72243 14.731 6.97125 14.6946 7.77252C14.4738 11.1042 10.2388 10.0792 10.7909 7.67646C10.9754 6.87518 11.1962 7.00402 11.5638 5.65801C12.1536 3.41579 8.2499 0.5 8.2499 0.5C8.2499 0.5 8.83968 1.71717 8.65521 2.61451C8.36032 4.15265 5.19317 3.60792 5.7089 6.26716C6.11422 8.22119 2.57943 8.95805 1.7688 7.00402C1.54796 6.49093 1.51158 6.01062 1.51158 6.01062C0.443742 7.54875 -0.0356179 8.86199 0.00205533 10.1752C0.148851 13.1543 1.80647 15.2688 4.01621 16.4543C4.20067 16.5504 4.42152 16.5504 4.60599 16.486C4.82683 16.3899 4.97363 16.2622 5.0113 16.0701L5.56341 14.0516C5.67383 13.6674 5.48936 13.3148 5.19577 13.0266L3.68624 11.5845C3.57582 11.5201 3.53944 11.3924 3.57582 11.2647C3.64987 11.1686 3.72261 11.0726 3.87071 11.0409L6.08044 10.6567C6.52213 10.5922 6.85339 10.3685 7.07423 10.0159L8.17845 8.31838C8.2525 8.22232 8.36292 8.15791 8.50972 8.15791C8.65651 8.15791 8.76693 8.22232 8.84098 8.31838L9.9452 10.0159C10.166 10.3685 10.4973 10.5922 10.939 10.6567L13.1487 11.0409C13.2591 11.0726 13.3696 11.1686 13.4059 11.2647C13.48 11.3924 13.4423 11.5212 13.3319 11.5845L11.8224 13.0266C11.5275 13.3148 11.343 13.6674 11.4547 14.0516L12.0068 16.0057C12.0432 16.1978 12.1913 16.3583 12.3745 16.4216C12.5953 16.486 12.8162 16.4532 13.0006 16.3571C14.9155 15.3005 16.4263 13.5069 16.9044 10.8804ZM6.96251 17.3833C7.99398 17.5438 9.0982 17.5438 10.1297 17.3517C10.3869 17.32 10.5714 17.1596 10.6454 16.903C10.6818 16.6792 10.609 16.4543 10.3882 16.3266L9.13587 15.5254C8.76823 15.3016 8.2525 15.3016 7.88356 15.5254L6.66892 16.3583C6.48445 16.5188 6.37403 16.7425 6.44808 16.9674C6.51953 17.1912 6.704 17.3517 6.96251 17.3833Z"
		{fill}
	/>
</svg>

<style>
	.icon {
    margin-bottom: 0.25rem
}
</style>
